import { authenticatedFetch } from '../api';
import { paths } from '../galaxyClient/types/Accounting';

export type UserSubscription = {
  id: number;
  userId: number;
  currencyCents: number;
  providerReference: string;
  providerData?: {
    partnerId: string;
    donationProgramId: string;
  };
  endDate: string | null;
  createdAt: string | null;
  paymentProviderName: string;
  status: string;
  amount?: number;
  interval?: string;
  intervalCount?: number;
  currencyCode: string;
  currencyName: string;
  currency: {
    name: string;
    code: string;
    cents: number;
    symbol: string;
  };
  items: {
    id: number;
    impacterIds: number[] | null;
    totalAmount: number;
    type: string;
  }[];
};

type UserSubscriptionResponse = {
  result: UserSubscription[];
  impacterCount: number;
};

export const getUserSubscriptions = async () =>
  await authenticatedFetch<UserSubscriptionResponse>('accounting/v2/subscriptions?me=true');

type CreateStripeSubscriptionParams = {
  affiliateName?: string;
  contentfulLandingPageId: string;
  currencyCode: string;
  amount: number;
  externalImpacterIds?: string[];
  categoryIds?: string[];
  paymentMethodId: string;
  language?: string;
  user?: { email?: string; firstName?: string; lastName?: string; emailOptIn?: boolean };
  verificationToken?: string;
};

type CreateStripeSubscriptionResponse = {
  subscription: { id: number; currentVersion: number; externalId: string };
  providerResponse: {
    providerReference: string;
    items: { id: string }[];
    pendingSetupIntent: { status: string; client_secret: string } | null;
  } | null;
  user: { id: number };
};

export const createStripeSubscription = async ({
  affiliateName,
  amount,
  categoryIds,
  currencyCode,
  externalImpacterIds,
  paymentMethodId,
  language,
  user,
  contentfulLandingPageId,
  verificationToken,
}: CreateStripeSubscriptionParams) => {
  return authenticatedFetch<CreateStripeSubscriptionResponse>(
    `accounting/v2/providers/stripe/subscriptions`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-request-check': verificationToken ?? '',
      },
      body: JSON.stringify({
        affiliateName,
        currencyCode,
        amount,
        externalImpacterIds,
        categoryIds,
        paymentMethodId,
        language,
        contentfulLandingPageId,
        user,
      }),
    },
  );
};

type SubscriptionReceiptResponse =
  paths['/v2/subscriptions/{externalId}/receipt']['get']['responses']['200']['content']['application/json'];

export const getSubscriptionReceipt = async (receipt?: string | number) =>
  await authenticatedFetch<SubscriptionReceiptResponse>(
    `accounting/v2/subscriptions/${receipt}/receipt`,
  );

export type SubscriptionResponse =
  paths['/v2/subscriptions/{id}']['get']['responses']['200']['content']['application/json'];

export const getSubscriptionById = (id: number) =>
  authenticatedFetch<SubscriptionResponse>(`accounting/v2/subscriptions/${id}`);

export const editSubscription = ({
  subscriptionId,
  items,
}: {
  subscriptionId: number;
  items: { id?: number; amount?: number; deleted?: boolean }[];
}) =>
  authenticatedFetch('accounting/v2/subscriptions/' + subscriptionId, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items,
    }),
  });
